import { AsyncState, loadingAsyncState } from 'widgets-for-react'
import { PressReleaseItem } from '../blocks/custom_blocks/widgets/pressReleasesBlock'
import { getPressRelease } from './api'

export type PressReleaseState = AsyncState<PressReleaseItem>

export const initialPressReleaseState = (id: string): PressReleaseState => loadingAsyncState(() => getPressRelease(id))
